export const allocations_display = {
  heading: "Allocations",
  empty: "No allocations yet",
  col_kind: "Kind",
  col_org: "Organization",
  col_part: "Part",
  col_repair: "Repair",
  col_amount: "Amount",
  col_note: "Note",
  empty_cell: "—",
  kind_part_sale: "Part sale",
  kind_platform_cut: "Platform cut",
  kind_withdrawal: "Withdrawal",
  kind_repair_spend: "Repair spend",
  kind_test: "Test",
  edit: "Edit",
  delete: "Delete",
  save: "Save",
  cancel: "Cancel",
  update_error: "Could not update allocation",
  delete_error: "Could not delete allocation",
};
